import React from "react";
import Layout from "../../reusables/layout/layout";
// import Login from "../../Component/loginform/login";
import Requisition from "../../Component/requisitionforms/requisition_bece_cas";
import BeceLogin from "../../Component/loginform/BeceLogin";

const PaymentLoginBece = () => {
  // const navigate = useNavigate();
  // const [password, setPassword] = useState('');
  // const [loading, setLoading] = useState(false);
  // const [rememberMe, setRememberMe] = useState(false);
  // const [username, setUsername] = useState('');

  // const dispatch = useDispatch();

  return (
    <>
      <div>
        <Layout>
          <BeceLogin
            examType={"BECE EXAMINATION"}
            url={"/user/schoolUser-login/04"}
            navigateTo={"/requisition/bece"}
          />
        </Layout>
      </div>
    </>
  );
};

export default PaymentLoginBece;
